import {
  WireCoverageBase,
  WireCoverageOption,
} from 'scenes/common/api/quote/types';

export enum WireSumInsuredType {
  Market = 'MarketValue',
  Agreed = 'AgreedValue',
  Unspecified = '',
}

type WireSumInsured = {
  type: WireSumInsuredType;
  amount: number;
};

export type WireMotorCoverageResponse = WireCoverageBase & {
  selected?: boolean;
  adjustmentRefIds: string[];
  excessRefIds: string[];
  sumInsured?: WireSumInsured;
  premiumRefIds: string[];
};

export type WireMotorCoverageRequest = WireMotorCoverageResponse & {
  options: WireCoverageOption[];
};
